// Change the symbol and color based on priority and domainGroup
export const priorityMap: any = {
  0: { color: "#1E2528", label: "invalid" },
  1: { color: "#AF1B26", label: "high" },
  2: { color: "#EFB32E", label: "medium" },
  3: { color: "#FFC627", label: "low" },
  4: { color: "#0071B9", label: "info" }
};

export function getDomainDisplayName(domain?: Api.Domain): string {
  return domain?.swComment ? domain.swComment : domain?.enumName || "";
}

export function domainComparator(allDomains: Api.Domain[]) {
  return function(a: Api.Domain, b: Api.Domain): number {
    const domA = allDomains.find((dom: Api.Domain) => dom.id == a.id);
    const domAName = getDomainDisplayName(domA);
    const domB = allDomains.find((dom: Api.Domain) => dom.id == b.id);
    const domBName = getDomainDisplayName(domB);

    return domAName > domBName ? 1 : domAName < domBName ? -1 : 0;
  };
}

export function faultComparator(allDomains: Api.Domain[]) {
  return function(a: Api.AnyFault, b: Api.AnyFault): number {
    const domA = allDomains.find((dom: Api.Domain) => dom.id == a.domain.id);
    const domAName = getDomainDisplayName(domA);
    const domB = allDomains.find((dom: Api.Domain) => dom.id == b.domain.id);
    const domBName = getDomainDisplayName(domB);

    return a.code > b.code
      ? 1
      : a.code < b.code
      ? -1
      : domAName > domBName
      ? 1
      : domAName < domBName
      ? -1
      : 0;
  };
}

export function localeComparator() {
  return function(a: Api.Locale, b: Api.Locale): number {
    return a.friendlyName > b.friendlyName ? 1 : a.friendlyName < b.friendlyName ? -1 : 0;
  };
}

export function getSupportedLocale(
  i18nLanguage: string,
  supportedLocales: Api.Locale[]
): Api.Locale | undefined {
  let selectedLocale = supportedLocales.find(
    (locale: Api.Locale) => locale.locale === i18nLanguage
  );
  if (!selectedLocale) {
    selectedLocale = supportedLocales.find(
      (locale: Api.Locale) => locale.locale.substring(0, 2) === i18nLanguage
    );
    if (!selectedLocale) {
      selectedLocale = supportedLocales.find((locale: Api.Locale) => locale.locale === "en-US");
      if (!!selectedLocale) {
      }
    }
  }
  return selectedLocale;
}

export function createPdApiSearchUrl(code?: string, language?: string): string {
  let searchUrl = "";
  if (!!code) {
    searchUrl += "code=" + code;
    if (language) {
      searchUrl += "&";
    }
  }
  if (language) {
    searchUrl += "lang=" + language;
  }
  return "faultview?" + searchUrl;
}

export function createFvSearchUrl(searchTerms: SearchTerms): string {
  let params = "";
  let searchParams = "";
  if (!!searchTerms.faultCode && !!searchTerms.domain && searchTerms.domain !== "-1") {
    params += searchTerms.domain + "/" + searchTerms.faultCode;
  }

  if (searchTerms.searchCode) {
    searchParams += "code=" + searchTerms.searchCode;
  }

  if (searchTerms.electrification && searchTerms.electrification !== "-1") {
    searchParams += "&electrification=" + searchTerms.electrification;
  }
  if (searchTerms.domainFilterInRequest && searchTerms.domainFilterInRequest !== "-1") {
    searchParams += "&domain=" + searchTerms.domainFilterInRequest;
  }

  if (searchTerms.inElectrification) {
    searchParams += "&inElectrification=" + searchTerms.inElectrification;
  }
  if (searchTerms.inCategoryDomain) {
    searchParams += "&inCategoryDomain=" + searchTerms.inCategoryDomain;
  }
  if (searchTerms.lang) {
    searchParams += "&lang=" + searchTerms.lang;
  }
  return "/" + params + "?" + searchParams;
}

export function createElementKey(ele?: number, cat?: number, dom?: number, id?: number): string {
  const retval = [];
  if (!!ele) {
    retval.push("ele:" + ele);
  }
  if (!!cat) {
    retval.push("cat:" + cat);
  }
  if (!!dom) {
    retval.push("dom:" + dom);
  }
  if (!!id) {
    retval.push("id:" + id);
  }
  return retval.join(",");
}

export function parseSearchTermsFromUrl(fromurl?: SearchTermsInUrl): SearchTerms {
  const returnValue: SearchTerms = {
    ...fromurl,
    domainFilterInRequest: fromurl?.domain,
    searchCode: fromurl?.code
  };
  return returnValue;
}

export function GetDomainName(domainId: string | undefined, faultDomains: Api.Domain[]): string {
  if (domainId === null) {
    return "";
  }
  const domain = faultDomains.find(x => x.id === +domainId);
  const displayName = getDomainDisplayName(domain);
  if (displayName === "") {
    return "All";
  }
  return displayName;
}

export function GetElectrificationName(
  electrificationValue: string | undefined,
  electrifications: Api.Electrification[]
): string {
  if (electrificationValue === null) {
    return "";
  }
  const electrification = electrifications.find(x => x.enumValue === +electrificationValue);
  return electrification?.enumName ?? "All";
}
